import api from "../api";

class FeeScheduleService {
  async getAllFeeSchedules() {
    return new Promise((res, reject) => {
      api
        .get("/feeSchedule")
        .then((data) => {
          res(data);
        })
        .catch((err) => {
          reject();
        });
    });
  }

  async getFeeScheduleById(id) {
    return new Promise((res, reject) => {
      api
        .get("/feeSchedule/" + id)
        .then((data) => {
          res(data);
        })
        .catch((err) => {
          reject();
        });
    });
  }

  async createFeeSchedule(obj) {
    return new Promise((res, reject) => {
      api
        .post("/feeSchedule", obj)
        .then((data) => {
          res(data);
        })
        .catch((err) => {
          reject();
        });
    });
  }

  async updateFeeSchedule(obj) {
    return new Promise((res, reject) => {
      api
        .put("/feeSchedule", obj)
        .then((data) => {
          res(data);
        })
        .catch((err) => {
          reject();
        });
    });
  }

  async deleteFeeSchedule(id) {
    return new Promise((res, rej) => {
      return api
        .delete("/feeSchedule/" + id)
        .then((data) => {
          res();
        })
        .catch((err) => {
          rej();
        });
    });
  }
}

const feeScheduleService = new FeeScheduleService();

export default feeScheduleService;
